<template>
  <v-container fluid class="pa-0">
    <Layout :hidePreview="!pickerPane && !previewPane" :hideFilter="$route.query[pk + 'filter'] === undefined"
      :hideOverlayRoute="true">

      <template v-slot:filter>
        <FilterPane :title="'ffff'" :pk="pk">
          <template v-slot:filters-content>
            <SupplierSelect v-model="suppliersfilter" multiple clearable externaledit class="ma-3">
            </SupplierSelect>

            <DefaultLifeCycleFilterGroup :pk="pk" :defaultActive="false"></DefaultLifeCycleFilterGroup>
          </template>
        </FilterPane>
      </template>

      <template v-slot:list>
        <ListPane :getListMethod="getListMethod" :locked-filters="lockedFilters" :optional-filters="filters"
          :paginationEnabled="true" :show-filter-tab="true" :show-sorting-tab="false" :itemsPerPage="25"
          :itemValueKey="'Id'" ref="ListPane" :open-function="openItem" :pk="pk">

          <template v-slot:prepend-item="{ list }">
            <v-row no-gutters align="stretch" class="flex-nowrap"
              style="border-bottom: 1px solid var(--v-disabled-base); background-color: #f9f9f9;">
              <v-col cols="0" style="max-width: calc(100% - 44px); min-width: calc(100% - 44px);">
                <v-container class="pa-0">
                  <v-row align="center" no-gutters style="height: 30px;">
                    <v-col cols="5">
                      <div class="px-3" style="max-width: calc(100% - 44px); min-width: calc(100% - 44px);">
                        {{ $t('servicesystem.common_objects.job_category.article') }}
                      </div>
                    </v-col>
                    <v-col cols="0" class="px-3">
                      {{ $t('servicesystem.common_objects.job_category.article_description') }}
                    </v-col>
                    <v-col cols="auto" class="px-3">
                      {{ $t('servicesystem.common_objects.job_category.article_count') }}
                    </v-col>
                  </v-row>
                </v-container>
              </v-col>
              <v-col v-if="list && list[0]" class="d-flex align-center justify-center">
                <v-progress-circular v-if="list.some(x => x.setLoading || x.removeLoading)" indeterminate size=" 18"
                  width="1">
                </v-progress-circular>
                <v-icon v-else size="20" color="success" class="fade-out-animated">
                  mdi-cloud-check-variant
                </v-icon>
              </v-col>
            </v-row>
          </template>

          <template v-slot:list-item="{ item }">
            <v-row :key="item.Id" :id="articleDomIdKey + item.Id" no-gutters align="stretch" class="flex-nowrap"
              style="border-bottom: 1px solid var(--v-disabled-base);">
              <v-col cols="0" style="max-width: calc(100% - 44px); min-width: calc(100% - 44px);">
                <v-container class="pa-0">
                  <v-row align="center" no-gutters style="height: 50px;">
                    <v-col cols="5">
                      <v-row v-if="!isPhoneBool && !pickerPane && !previewPane" no-gutters>
                        <v-col cols="0" style="max-width: calc(100% - 44px); min-width: calc(100% - 44px);">
                          <ListItem v-if="item.Article" :item="item.Article" :showStoreItems="false" class="px-1" @click="openItem(item)">
                          </ListItem>
                          <v-list-item v-else class="error--text">
                            Article "{{ item.ArticleId }}" not found.
                          </v-list-item>
                        </v-col>
                        <v-col v-if="item.Article && (previewPane != item.ArticleId)" cols="auto"
                          class="hovercol d-flex align-center justify-center px-3" @click.stop="openPreview(item)">
                          <v-icon size="20">
                            mdi-view-split-vertical
                          </v-icon>
                        </v-col>
                      </v-row>

                      <router-link v-else class="primary--text minimalLink px-3" style="font-size: 13px;"
                        :to="{ name: 'ViewArticle', params: { articleId: item.Article.Id, articleNumber: item.Article.ArticleNumber } }">
                        {{ item.Article.ArticleNumber }}
                      </router-link>
                    </v-col>
                    <v-divider vertical></v-divider>
                    <v-col cols="0" class="px-3">
                      <v-text-field v-model="item.newArticleDescription" :loading="item.setLoading" class="py-0 my-0"
                        hide-details @input="debounceSet(item)" @blur="set(item)" @keypress.enter="set(item)">
                      </v-text-field>
                    </v-col>
                    <v-col cols="auto" class="px-3">
                      <BNumberField v-model="item.newArticleCount" :min="0" :max="1000000000"
                        :adjustWidthToContent="true" :loading="item.setLoading" class="mr-2" @input="debounceSet(item)"
                        @keypress.enter="set(item)">
                      </BNumberField>
                    </v-col>
                  </v-row>
                </v-container>
              </v-col>
              <v-hover v-slot="{ hover }">
                <v-col cols="auto" class="hovercol2 d-flex align-center justify-center px-3"
                  @click.stop="(item.removeLoading || item.setLoading) ? undefined : remove(item)">
                  <v-icon v-if="!item.removeLoading" size="20" v-text="hover ? 'mdi-delete-empty' : 'mdi-delete'">
                  </v-icon>
                  <v-progress-circular v-else indeterminate size="20" width="2" color="primary">
                  </v-progress-circular>
                </v-col>
              </v-hover>
            </v-row>
          </template>

        </ListPane>
      </template>

      <template v-slot:preview>
        <PreviewPane v-if="!pickerPane" :articleNumber="previewPane" :closePreviewFunc="closePreview">
        </PreviewPane>
        <ArticlePickerPane v-else :locked-filters="lockedPickerFilters" multiple @select="sf => select(sf)">
        </ArticlePickerPane>
      </template>

    </Layout>
  </v-container>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import DefaultLifeCycleFilterGroup from "@/components/DefaultLifeCycleFilterGroup.vue";
import BNumberField from '@/components/Inputs/BNumberField.vue';
import SupplierSelect from "@/components/Inputs/EntityDropdowns/SupplierSelect2.vue";
import ListItem from "@/components/ListItems/ArticleListItem2.vue";
import FilterPane from "@/components/Sections/Panes/FilterPane.vue";
import ListPane from "@/components/Sections/Panes/ListPane.vue";
import PreviewPane from "@/components/Sections/Panes/PreviewArticle.vue";
import FilterQueryMixin from "@/helpers/Mixins/FilterQueryMixin.js";
import Layout from "@/views/layouts/PreviewableList.vue";
import { debounce } from "debounce";
import Vue from "vue";
import ArticlePickerPane from "../articles/ArticlePickerPane.vue";

export default {
  name: "ViewMachineModelCommonParts",
  props: {},
  components: {
    PreviewPane,
    Layout,
    ListItem,
    FilterPane,
    ListPane,
    SupplierSelect,
    DefaultLifeCycleFilterGroup,
    ArticlePickerPane,
    BNumberField,
  },
  mixins: [clientAPI, FilterQueryMixin],

  data() {
    return {
      pk: 'JCAL-',
      domIdKey: 'commonpart-',
      articleDomIdKey: 'article-',
    };
  },

  methods: {
    async getListMethod(filters) {
      var list = await this.getJobCategoryArticlesFromFilter(filters);
      list.Content.forEach(e => {
        e.newArticleCount = parseFloat(`${e.ArticleCount}`);
        e.newArticleDescription = `${e.ArticleDescription}`;
      });
      return list;
    },

    remove(item) {
      Vue.set(item, 'removeLoading', true);
      this.removeArticleFromJobCategory(item.Id)
        .then(() => {
          Vue.set(item, 'removeLoading', false);
          this.$refs.ListPane.handleremoved(item);
        });
    },

    set(item) {
      if (item.newArticleCount == item.ArticleCount && item.newArticleDescription == item.ArticleDescription) {
        return;
      }
      else {
        Vue.set(item, 'setLoading', true);
        item.ArticleCount = `${item.newArticleCount}`;
        item.ArticleDescription = `${item.newArticleDescription}`;

        this.changeJobCategoryArticle(item)
          .then(() => {
            Vue.set(item, 'setLoading', false);
            this.$refs.ListPane.handlechanged(item);
          });
      }
    },

    debounceSet: debounce(async function (item) {
      this.set(item);
    }, 700),

    async select(selectionFilter) {
      await this.addArticleToJobCategory(this.jobCategoryId, selectionFilter);
      this.$refs.ListPane.fetch();
    },

    openPicker() {
      this.pickerPane = 'article';
    },
    closePicker() {
      this.pickerPane = undefined;
    },

    openPreview(item) {
      if (this.pickerPane) {
        this.closePicker();
      }
      this.previewPane = item.ArticleId;
    },
    closePreview() {
      this.previewPane = undefined;
    },

    openItem(item) {
      //console.log('openItem', item);
      var article = item.Article;
      this.$router.push({ name: 'ViewArticle', params: { articleId: article.Id, articleNumber: article.ArticleNumber } })
    },

    handleadded(item) { this.$refs.ListPane.handleadded(item) },
    handlechanged: (item) => this.$refs.ListPane.handlechanged(item),
  },

  computed: {
    jobCategory() {
      return this.containerItem;
    },

    jobCategoryId() {
      return this.$route.params.categoryId;
    },

    PreviewCustomer() { return this.$store.getters["JobHub/JobPreview/PreviewCustomer"]; },

    filters() {
      if (this.$route.query && Object.keys(this.$route.query).some((x) => x.includes("filter-"))) {
        var filters = {
          SearchWord: this.getQueryParam("filter-keyword", undefined),
          ActiveState: this.getQueryParam("filter-active", 0),
          SupplierIdList: this.suppliersfilter,
          IsTechnicianPart: this.getQueryParam("filter-technicianpart", 0),
        };
        return filters;
      }
      else {
        return null;
      }
    },

    lockedFilters() {
      return { ArticlesFromJobCategoryIdList: [this.jobCategoryId] };
    },

    lockedPickerFilters() {
      return { ExcludeArticlesFromJobCategoryIdList: [this.jobCategoryId] };
    },

    suppliersfilter: {
      get() { return this.getQueryParam("filter-suppliers", []); },
      set(update) { this.setQueryParam("filter-suppliers", update); },
    },

    pickerPane: {
      get() {
        return this.$route.query.picker;
      },
      set(update) {
        this.$router.replace({ params: this.$route.params, query: { ...this.$route.query, picker: update } });
      },
    },

    previewPane: {
      get() {
        return this.$route.query.preview;
      },
      set(update) {
        this.$router.push({ query: { ...this.$route.query, preview: update } });
      },
    },

    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    }
  },

  watch: {},
};
</script>

<style>
.flip-list-move {
  transition: transform 0.5s;
}

.handle {
  cursor: ns-resize;
}

.no-move {
  transition: transform 0s;
}

.ghost {
  opacity: 1;
  border: 2px solid var(--v-primary-base) !important;
}

.fade-out-animated {
  -webkit-animation: fadeinout 2s linear forwards;
  animation: fadeinout 2s linear forwards;
  opacity: 0;
}

@-webkit-keyframes fadeinout {
  1% {
    opacity: 0.8;
  }

  50% {
    opacity: 0.8;
  }

  100% {
    opacity: 0;
  }
}

@keyframes fadeinout {
  1% {
    opacity: 0.8;
  }

  50% {
    opacity: 0.8;
  }

  100% {
    opacity: 0;
  }
}
</style>